import React from 'react';
import { Link } from 'react-router-dom';
import { FiHome, FiChevronRight } from 'react-icons/fi';

interface BreadcrumbItem {
  label: string;
  href?: string;
  icon?: React.ComponentType<any>;
}

interface AdminBreadcrumbProps {
  items: BreadcrumbItem[];
}

const AdminBreadcrumb: React.FC<AdminBreadcrumbProps> = ({ items }) => {
  // Always include home as the first item
  const allItems = [
    { label: 'หน้าหลัก', href: '/admin/dashboard', icon: FiHome },
    ...items
  ];

  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol className="inline-flex items-center space-x-1 md:space-x-3">
        {allItems.map((item, index) => {
          const isLast = index === allItems.length - 1;
          const Icon = item.icon;

          return (
            <li key={index} className="inline-flex items-center">
              {index > 0 && (
                <FiChevronRight className="w-4 h-4 text-gray-400 mx-1" />
              )}

              {item.href && !isLast ? (
                <Link
                  to={item.href}
                  className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600 transition-colors duration-150"
                >
                  {Icon && <Icon className="w-4 h-4 mr-2" />}
                  {item.label}
                </Link>
              ) : (
                <span className={`inline-flex items-center text-sm font-medium ${
                  isLast ? 'text-gray-900' : 'text-gray-700'
                }`}>
                  {Icon && <Icon className="w-4 h-4 mr-2" />}
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default AdminBreadcrumb;